import Icons from "../../../../../components/icons";

const HistoryGrid = ({ data }) => {
  return (
    <div>
      <table style={{ width: "100%" }}>
        <div className="table_heading">
          <p
            className="td_border !px-1 !w-[85%] text-md !text-[#757575]"
            style={{ padding: "21px", width: "20%" }}
          >
            Action
          </p>
          <p
            className="td_border !px-2.5 text-md !text-[#757575]"
            style={{ padding: "21px", width: "20%" }}
          >
            Date
          </p>
          <p
            className="td_border !px-1 text-md !text-[#757575]"
            style={{ padding: "21px", width: "20%" }}
          >
            User
          </p>
        </div>

        {data?.map((item) => (
          <div
            key={item.id}
            className="table_body items-center"
            style={{ background: "#FFFFFF" }}
          >
            <p
              className="td_border !w-[80%] text-md"
              style={{ padding: "21px" }}
            >
              {item?.file_name && <Icons id={"fileIcon"} />}
              <span className="ml-1">{item?.file_name || item?.website_url || 'form'}</span>
            </p>

            <div
              className="td_border"
              style={{ padding: "21px", width: "20%" }}
            >
              <p
                className={` px-[15px] rounded-full !w-fit !h-[27px] flex justify-center items-center text-md`}
              >
                {item?._created_at?.split('T')?.[0]?.split('-').reverse().join('/')}
              </p>
            </div>

            <p
              className="td_border text-md"
              style={{ padding: "21px", width: "20%" }}
            >
              {item?.username}
            </p>
          </div>
        ))}
      </table>
    </div>
  );
};

export default HistoryGrid;
